/**
 * Walidatory i wyrażenia regularne współdzielone między backend (apps/api) i frontend (apps/admin).
 *
 * Tylko string-based, zero zależności zewnętrznych — paczka musi działać w bundlerze Vite.
 */

/** Regex dopasowujący UUID v4 (lowercase lub uppercase, z myślnikami). */
export const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
